module.exports = __webpack_public_path__ + "assets/img/starter_custom_component.bbd92b0e.jpg";